module.exports = __webpack_public_path__ + "img/zero_trial.09f219cd.png";